
import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { GlobalService } from 'src/app/services/global.service';
import { HttpService } from 'src/app/services/http.service';
import * as enLocale from 'date-fns/locale/en';
import { DatepickerOptions } from 'ng2-datepicker';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { configs } from 'src/app/configs/app.config';


@Component({

  selector: 'app-addcard',
  templateUrl: './addcard.component.html',
  styleUrls: ['./addcard.component.scss']
})
export class AddcardComponent {


  public isSubmitted = false;
  public addCard: FormGroup;
  public scoreName: any;
  // public stream: boolean;
  public organisationOptions = this.globalService.organisationOptions;
  public startDate: Date;
  public endDate: any;
  public getData: any;
  public peers: any;
  public successMessage: string = '';
  public errorMessage: string = "";
  public warningMessage: string = "";
  public dropdownSettings: IDropdownSettings = {};
  public fromdateSelected: boolean = false;

  public optionsStartDate: DatepickerOptions = {
    locale: enLocale,
    placeholder: 'Select Date',
    displayFormat: 'DD/MM/YY'
  };

  public optionsEndDate: DatepickerOptions = {
    locale: enLocale,
    placeholder: 'Select Date',
    displayFormat: 'DD/MM/YY',
  };

  @Output() valueChange = new EventEmitter();
  @Input('cardName') cardName: string = "";//'benchMarking
  public kpiList: Array<any> = [];

  constructor(public globalService: GlobalService, private formBuilder: FormBuilder, private httpService: HttpService, public cd: ChangeDetectorRef) {

    this.addCard = this.formBuilder.group({
      scoreName: ['', Validators.required],
      scoreName_select_name: [''],
      peers: ['', Validators.required],
      peers_select_name: [''],
      startDate: [''],
      endDate: [''],
      // stream: [''],
      deviceCategory: [''],
      deviceCategory_select_name: [''],
      kpiType: ['', Validators.required],
      kpiType_select_name: [''],
      network: [''],
      network_select_name: [''],
      locationArray: [],
      timeWindowArray: [],
      deviceCategoryArray: [],
      appVersionArray: [],
      networkArray: [],
      speedArray: [],
      apps: [],
      platformArray: [],
    });

  }


  dateSelect(event) {
    this.endDate = null;

    this.optionsEndDate.minDate = event;
    this.cd.detectChanges();
    setTimeout(() => {
      this.fromdateSelected = true;
    }, 0);

  }

  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: false
    };
    this.addCard.get('kpiType').setValue('Index');
  }

  forPopupClose() {
    this.globalService.showPopUp = "";
    document.body ? document.body.classList.remove('no-scroll') : '';
  }

  public changeSelection(selectedValue): void {
    setTimeout(() => {
      let option = selectedValue['fieldName'];
      this.addCard.controls[option].setValue(selectedValue['id']);
      if (selectedValue['fieldName'] == 'kpiType') {
        this.fetchKpiList(this.addCard['controls']['kpiType']['value']);
        this.addCard['controls']['scoreName'].setValue('');
        this.addCard['controls']['scoreName_select_name'].setValue('');
      }
    }, 0);
  }

  public fetchKpiList(val): void {
    this.kpiList = [];
    this.httpService.createGetRequest(configs['api']['fetchKpiList'] + this.globalService.order_id + '?raw=' + val).subscribe((response: any) => {
      if (response)
        this.kpiList = this.globalService.toObject('', response);
      // this.kpiList = this.kpiList.slice();
    });
  }
  clean(obj) {
    var arr = [];
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "--" || obj[propName] === "aN--NaN" || obj[propName] === "NaN--NaN" || obj[propName].length === 0 || obj[propName] === " " || obj[propName] === "select" || obj[propName] === "Select" || (obj[propName] && obj[propName][0] === "select")) {
        delete obj[propName];
      }
    }
    return obj;
  }

  onSubmit(event) {
    this.errorMessage = "";
    this.warningMessage = "";
    this.successMessage = "";
    this.isSubmitted = true;
    this.globalService.scrollToTop();
    let checkValidation = (this.cardName == 'benchmarking') ? (this.addCard['controls']['scoreName'].valid && this.addCard['controls']['peers'].valid) : (this.addCard['controls']['scoreName'].valid);
    if (checkValidation) {
      let obj = {
        "type": this.globalService.orderType,
        "scoreName": this.addCard.value['scoreName'] ? this.addCard.value['scoreName'] : undefined,
        "mainApp": this.globalService.selectedOrder['mainApp'] ? this.globalService.selectedOrder['mainApp'] : undefined,
        "telco": this.addCard['controls']['networkArray']['value'] ? this.globalService.getDataAsString(this.addCard['controls']['networkArray']['value']) : undefined,
        "speed": this.addCard['controls']['speedArray']['value'] ? this.globalService.getDataAsString(this.addCard['controls']['speedArray']['value']) : undefined,
        "location": this.addCard['controls']['locationArray']['value'] ? this.globalService.getDataAsString(this.addCard['controls']['locationArray']['value']) : undefined,
        "appVersion": this.addCard['controls']['appVersionArray']['value'] ? this.globalService.getDataAsString(this.addCard['controls']['appVersionArray']['value']) : undefined,
        "startDate": this.globalService.convertDate(this.addCard['controls']['startDate']['value']) ? this.globalService.convertDate(this.addCard['controls']['startDate']['value']) : "",
        "timeWindow": this.addCard['controls']['timeWindowArray']['value'] ? this.globalService.getDataAsString(this.addCard['controls']['timeWindowArray']['value']) : undefined,
        "deviceCategory": this.addCard['controls']['deviceCategoryArray']['value'] ? this.globalService.getDataAsString(this.addCard['controls']['deviceCategoryArray']['value']) : undefined,
        "endDate": this.globalService.convertDate(this.addCard['controls']['endDate']['value']) ? this.globalService.convertDate(this.addCard['controls']['endDate']['value']) : "",
        "appName": this.addCard['controls']['apps']['value'] ? this.globalService.getDataAsString(this.addCard['controls']['apps']['value']) : undefined,
        // "videoStreamType":this.addCard['controls']['stream']['value'] ? this.addCard['controls']['stream']['value'] : undefined,
        "platform": this.addCard['controls']['platformArray']['value'] ? this.globalService.getDataAsString(this.addCard['controls']['platformArray']['value']) : undefined,
        "raw": this.addCard['controls']['kpiType'] ? ((this.addCard['controls']['kpiType']['value'] == 'Index' || this.addCard['controls']['kpiType']['value'] == false) ? false : true) : false,
        cardType: this.cardName,
      };
      if (this.cardName == 'benchmarking') {
        obj["peers"] = this.addCard['controls']['peers']['value'] ? this.addCard['controls']['peers']['value'] : undefined
      }
      this.httpService.createPostRequest(configs['api']['addCard'], this.clean(obj), this.globalService.order_id).subscribe((response: any) => {
        this.valueChange.emit('ok');
        this.globalService.scrollToTop();
        this.successMessage = 'success';
        document.body ? document.body.classList.remove('no-scroll') : '';
        setTimeout(() => {
          this.globalService.showPopUp = "";
        }, 2500)
      },
        (error) => {
          this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';

          this.warningMessage = (error.error['statusCode'] && error.error['statusCode'] === 406) ? error.error['statusMessage'] : '';
          setTimeout(() => {
            this.errorMessage = "";
            this.warningMessage = "";
          }, 6000);
          this.globalService.scrollToTop();
        });
    } else {
      this.errorMessage = "Please fill the required fields."
      return false;
    }
  }
  ngDoCheck() {
    this.cd.detectChanges();
  }
}
